import {
    IDataArray,
} from "./../../shared/index"

export enum SurveyActionType {
    Notified = 'Notified',
    Ignored = 'Ignored',
    Viewed = 'Viewed',
    Completed = 'Completed',
    IgnoredForever = 'IgnoredForever'
}

export class SurveyUserActions implements IDataArray {
    public Pkid = 0;
    public SurveyId: number;
    public UserId: number;
    public ActionDate: Date;
    public ActionId: number;

    public ActionVal: SurveyActionType;

    public GetById(): number {
        return this.Pkid;
    }
}